'use strict';
/**
 * Framing that fills the circle with the head and just catches the shoulders. Measured on julia.glb;
 * it is the starting point for any preset that has not been tuned individually.
 */
export const DEFAULT_BUST_VIEW = { cameraView: 'head', cameraY: -0.06, cameraDistance: 0 };
/** Single source of truth for the built-in TalkingHead avatars. */
export const avatarPresets = [
    // julia.glb is the avatar the bust framing was measured on (SXI-7574 spike).
    { avatarId: 'julia.glb', avatarName: 'Julia', avatarIcon: 'julia-thumbnail.png', voice: 'Alloy', body: 'F', bustView: DEFAULT_BUST_VIEW },
    { avatarId: 'david.glb', avatarName: 'David', avatarIcon: 'david-thumbnail.png', voice: 'Echo', body: 'M' },
    { avatarId: 'line.glb', avatarName: 'Line', avatarIcon: 'line-thumbnail.png', voice: 'Shimmer', body: 'F' },
    { avatarId: 'basti.glb', avatarName: 'Basti', avatarIcon: 'basti-thumbnail.png', voice: 'Echo', body: 'M' },
    { avatarId: 'katya.glb', avatarName: 'Katya', avatarIcon: 'katya-thumbnail.png', voice: 'Shimmer', body: 'F' }
];
/** Look up a preset by its `avatarId` (e.g. `'julia.glb'`). */
export function getAvatarPreset(avatarId) {
    if (!avatarId)
        return null;
    return avatarPresets.find((p) => p.avatarId === avatarId) || null;
}
/**
 * Bust framing for an avatar, falling back to {@link DEFAULT_BUST_VIEW}. The fallback is deliberate:
 * an untuned or custom GLB gets a sensible head-and-shoulders frame rather than no framing at all.
 */
export function getBustView(avatarId) {
    const preset = getAvatarPreset(avatarId);
    return (preset && preset.bustView) || DEFAULT_BUST_VIEW;
}
/** Default preset (first entry), used when none is set or the id is unknown. */
export function getDefaultAvatarPreset() {
    return avatarPresets[0];
}
/**
 * Resolve a GLB URL for the given `avatarId` against the avatar base.
 * - If `avatarId` is already an absolute URL, it is used as-is.
 * - Otherwise it is treated as a preset id (GLB filename); unknown ids fall
 *   back to the default preset's GLB.
 *
 * @param avatarId preset id (GLB filename) or an absolute GLB URL
 * @param avatarBase e.g. `https://cdn.search.zoovu.com/assets/avatars`
 */
export function getAvatarGlbUrl(avatarId, avatarBase) {
    if (avatarId && /^https?:\/\//i.test(avatarId)) {
        return avatarId;
    }
    const preset = getAvatarPreset(avatarId) || getDefaultAvatarPreset();
    return `${avatarBase}/${preset.avatarId}`;
}
